/**
 * The key the product page gives its review dialog.
 *
 * The dialog seeds its rating and text from the viewer's own review when it
 * mounts, and it is mounted before the review listeners answer, so the page
 * keys it on that review (its id, or 'new') to remount it once the review
 * resolves or goes away. `settled` says whether the viewer's own review had
 * been looked up when the key was taken.
 *
 * Held still while the dialog is open, once settled. Saving or deleting moves
 * the review under the open dialog (a Firestore write shows locally the moment
 * it is made and a refused one rolls back; a guest's review lands when the
 * server writes it, before the call returns), and a remount then dropped the
 * dialog's busy state mid-save and, on a rollback, the text the buyer typed. A
 * dialog opened before the lookup settled still takes the settled key, once, so
 * a review that arrives a moment late is still the one it edits.
 */
export type ReviewDialogKey = { key: string; settled: boolean };

/** The key to hold next. Returns `held` itself when nothing changes. */
export function nextReviewDialogKey(held: ReviewDialogKey, live: ReviewDialogKey, open: boolean): ReviewDialogKey {
  if (open && held.settled) return held;
  return held.key === live.key && held.settled === live.settled ? held : live;
}
